import React from 'react';
import PublicationsSeriesFilter from './filters/PublicationsSeriesFilter';
import PublicationsDatePublishedFilter from './filters/PublicationsDatePublishedFilter';

export default function PublicationsSearchFilters() {
  return (
    <>
      <PublicationsSeriesFilter />
      <PublicationsDatePublishedFilter />
    </>
  );
}
